module.exports = __webpack_public_path__ + "static/img/embed.f4e4f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/embed.png
// module id = uSEn
// module chunks = 14